package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class UploadClubImage(
    val data: UploadClubImageData,
)
@Serializable
data class UploadClubImageData(
    val clubName: String,
    val coachesAllowed: Long,
    val id: String,
    val imageUrl: String,
    val organization: String,
    val payment: Payment,
    val playersAllowed: Long,
    val type: String,
)